import React from 'react';
import { getTimeRangeLabel, TimeRangeEnum } from './types';
import GenericSelect from '../../GenericSelect/GenericSelect';
import { AvailableIcons, Icon, Tooltip } from 'src/components-dummy';
import { Option } from '../../GenericSelect/types';
import { getPreviousMonthsDateRange } from 'src/components-bl/Analytics/utils/utils';

interface ITimeRangeSelectorProps {
  timeRange: TimeRangeEnum;
  setTimeRange: (timeRange: TimeRangeEnum) => void;
}
export const TimeRangeSelector = ({ timeRange, setTimeRange }: ITimeRangeSelectorProps) => {
  const handleChange = (event: any) => {
    setTimeRange(event.target.value);
  };
  const visibleOptions = [
    TimeRangeEnum.Last1Day,
    TimeRangeEnum.Last1Week,
    TimeRangeEnum.Last1Month,
    TimeRangeEnum.Last30Days,
    TimeRangeEnum.Last3Months,
  ];
  const timeOptions: Option<TimeRangeEnum>[] = visibleOptions.map(val => ({
    value: val,
    label: getTimeRangeLabel(val),
  }));
  return (
    <GenericSelect<TimeRangeEnum>
      value={timeRange}
      onChange={handleChange}
      options={timeOptions}
      icon={<Icon name={AvailableIcons.Calendar} className='added-icon' />}
      placeholder='Select time range...'
      renderOption={option => (
        <Tooltip value={getPreviousMonthsDateRange(option.value)} position='right center'>
          <span>{option.label}</span>
        </Tooltip>
      )}
    />
  );
};
